import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { t } from '@/core/localization';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
import { workflowItemProcessedSnackbarDuration } from '@/warehouse/constants';
import { createAppAsyncThunk } from '@/warehouse/helpers';
import { crossdockReceiptApi } from '../crossdockReceipt.api';
// TODO: finish work here when backend part is done.
const acceptTrackableReceiptItem = createAppAsyncThunk('receipt/acceptTrackableReceiptItem', async (trackableItemAccept, { getState, dispatch, rejectWithValue }) => {
    const { setSearchTerm } = useItemWorkflowTableStore.getState();
    // const { open, data: acceptItem } = useAppSelector((state) => state.receipt.acceptTrackableReceiptItemDialog);
    const { brand, article } = getState().crossdockReceipt.acceptTrackableReceiptItemDialog.data ?? {};
    try {
        // A single snackbar is allowed at one moment.
        closeSnackbar();
        // Clear search text field BEFORE `acceptTrackableReceiptItem` endpoint call, not at the end of this thunk.
        // That's important to avoid bug (https://global-parts.atlassian.net/browse/GPI-367) when cursor jumps to the next row that
        // meets the search criteria.
        // `ReceiptItemsTable` reacts on `data` has been changed (in `acceptTrackableReceiptItem` onQueryStarted optimistic update
        // of `item.receiptedQuantity`) and in case the search term still exists relocates currents selection to another row.
        setSearchTerm('');
        // const receiptItemAccept: TrackableReceiptItemAccept = {
        // 	receiptItemId: receiptItem.receiptItemId,
        // 	invoiceId: receiptItem.invoiceId,
        // 	trackableQrCode: receiptItem.trackableQrCode,
        // 	isBlocked: receiptItem.isBlocked,
        // };
        await dispatch(crossdockReceiptApi.endpoints.acceptTrackableReceiptItem.initiate(trackableItemAccept)).unwrap();
        enqueueSnackbar({
            // Should not prevent duplicate since another quantity of the same article may be accepted.
            // key: receiptItem.receiptItemId,
            // preventDuplicate: true,
            //
            // @ts-expect-error wtf?
            // variant: receiptItem.isBlocked ? 'receiptBlockSuccess' : 'receiptSubmissionSuccess',
            variant: 'receiptBlockSuccess',
            // brand: receiptItem.brand,
            // article: receiptItem.article,
            brand,
            article,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            autoHideDuration: workflowItemProcessedSnackbarDuration,
        });
        // Should not be used here, see comment above.
        // setSearchTerm('');
    }
    catch (error) {
        const errorData = error.data;
        if (errorData?.Message?.includes('The received quantity more that available')) {
            // TODO: later. Get rid of this when new backend will be ready (or we still have this workaround even with new backend).
            enqueueSnackbar({
                variant: 'error',
                header: trackableItemAccept.isBlocked ? t('receipt.item.block.failed') : t('receipt.item.reception.failed'),
                body: trackableItemAccept.isBlocked
                    ? t('blocked.quantity.more.than.available')
                    : t('received.quantity.more.than.available'),
                persist: false,
            });
        }
        else {
            enqueueSnackbar({
                variant: 'error',
                header: trackableItemAccept.isBlocked ? t('receipt.item.block.failed') : t('receipt.item.reception.failed'),
                body: getErrorFromException(error),
                persist: true,
            });
        }
        console.log(`Receipt item ${trackableItemAccept.isBlocked ? 'block' : 'accept'} error:`, error);
        if (error instanceof Error) {
            return rejectWithValue(`Cannot accept receipt item: ${error.message}`);
        }
        else if ('status' in error && 'data' in error) {
            return rejectWithValue(getErrorFromException(error));
        }
        return rejectWithValue('Server unexpected error');
    }
});
export { acceptTrackableReceiptItem };
